// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3L2Ag{padding:0}", ""]);
// Exports
exports.locals = {
	"mobileConsentContent": "_3L2Ag"
};
module.exports = exports;
